import { apiUrls } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'
import getFilters from '../utils/getFilters'
import sortChildFilters from 'pages/Filters/utils/sortChildFilters'

interface useInitProps {
  isTemporary: boolean
  getValues: Function
  setFilters: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  currentCustomer: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {

    let filters = []
    const filtersPromise = getFilters().then((data) => {
      filters = data
    })

    Promise.all([filtersPromise]).then(() => {
      props.setFilters(sortChildFilters(filters))
    })

    if (props.id !== undefined) {
      loadRecord(apiUrls.permissions, props.id).then((data) => {
        if(props.isTemporary){
          data.name = ''
        }
        props.reset(data)

        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } else {
      props.setDataLoaded(true)
      props.setShowOverlay(false)
    }
  }, [props.currentCustomer])
}

export default useInit
